import { create } from 'zustand';

export const useDataStore = create(set => ({
  user: null,
  setUser: user => set({ user }),

  selectedDealer: null,
  setSelectedDealer: selectedDealer => set({ selectedDealer }),

  selectedEntity: null,
  setSelectedEntity: selectedEntity => set({ selectedEntity }),
}));